import { CONFIG_DEFAULT } from "./defaults";
import { BodyMutationObserver } from "./body-mutation-observer";
import { checkLicense } from "./license/license-check";
import { getRegisteredGlobal, registerGlobal } from "@trumpf/ux.utils";
import { TrumpfUxConfig } from "./globals";

export default async (): Promise<void> => {
    if (typeof window === "undefined") {
        return;
    }
    setupConfig();
    checkLicense();
    new BodyMutationObserver();
};

function setupConfig(): void {
    const config = getRegisteredGlobal<TrumpfUxConfig>("trumpf.ux") || {};
    registerGlobal({ ...CONFIG_DEFAULT, ...config }, "trumpf.ux");
}
